// extracted by mini-css-extract-plugin
export var content = "_m7-1";
export var fullScreen = "_m7-0";